import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./locales/en";
import vi from "./locales/vi";
import { KeyLocalStore } from "~/common/constants";

const resources = {
  en,
  vi,
};
export const languageConfig = {
  defaultLanguage: "vi",
  languages: {
    vi: {
      label: "Vietnamese",
      icon: "🇻🇳",
    },
    en: {
      label: "English",
      icon: "🇺🇸",
    },
  },
};
const pipeResources = (resources: any) =>
  Object.fromEntries(
    Object.entries(resources).map(([lang, value]) => [
      lang,
      { ...(value as any), translation: value },
    ])
  );

// Lấy ngôn ngữ đã lưu từ localStorage
const getStoredLanguage = () => {
  const storedLang = localStorage.getItem(KeyLocalStore.language);
  return storedLang &&
    Object.keys(languageConfig.languages).includes(storedLang)
    ? storedLang
    : languageConfig.defaultLanguage;
};

i18n.use(initReactI18next).init({
  compatibilityJSON: "v4",
  // Lần đầu vào (localStorage trống) → mặc định "vi".
  // Nếu user đã chọn ngôn ngữ → ghi nhớ qua các lần load.
  lng: getStoredLanguage(),
  resources: pipeResources(resources),
  fallbackLng: languageConfig.defaultLanguage,
  interpolation: {
    escapeValue: false,
  },
});

// Đồng bộ localStorage khi user chủ động đổi ngôn ngữ
i18n.on("languageChanged", (lng) => {
  localStorage.setItem(KeyLocalStore.language, lng);
});

export default i18n;
